module.exports = (that) => {
	// 消息提示
	that.$msg = (obj) => {
		that.$message(obj);
	}

	// 错误提示
	that.$err = (obj) => {
		that.$message.error(obj);
	}

	// 警告提示
	that.$warn = (message) => {
		that.$message.warning(message);
	}

	// 成功提示
	that.$success = (message) => {
		that.$message.success(message);
	}

	/* 
		确认框,type类型与提示框一致，success/warning/info/error,都是非必填项
		this.$model({
			content:'',//内容
			title:'',//标题
			type:'',//提示类型
			center:boolean,//布局方式，true为居中布局，默认false右侧
			confirmButtonText:'',//确认按钮文字
			cancelButtonText:'',//取消按钮文字
			success:()=>{},//确认函数
			fail:()=>{},//取消桉树
		})
	*/
	/*
		this.$model({
			content: '确定要删除当前客服吗？',
			title: '删除客服', //标题
			success: () => {
				this.$post({
					url:'',
					loading: '删除中',
					hint: '删除成功',
					success: res => {
						this.$refs.editPassword.show = false;
					}
				});
			}
		});
   */
	that.$model = (obj) => {
		that.$confirm(obj.content || '是否确定继续操作?', obj.title || '提示', {
			confirmButtonText: obj.confirmText || '确定',
			cancelButtonText: obj.cancelText || '取消',
			type: obj.type || 'warning',
			center: obj.center || false,
		}).then(() => {
			obj.success && obj.success();
		}).catch(() => {
			obj.fail && obj.fail();
		});
	}

	/*
		弹窗输入内容,邮箱正则： /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
		this.$input({
			content:'',//内容
			title:'',//标题
			regular:'',//正则表达式
			message:'',//输入错误提示文字
			confirmButtonText:'',//确认按钮文字
			cancelButtonText:'',//取消按钮文字
			success:()=>{},//确认函数
			fail:()=>{},//取消桉树
		})
	*/
	that.$input = (obj) => {
		that.$prompt(obj.content || '请输入内容', obj.title || '请输入', {
			confirmButtonText: obj.confirmText || '确定',
			cancelButtonText: obj.cancelText || '取消',
			inputPattern: obj.regular || '',
			inputErrorMessage: obj.message || '输入内容不正确'
		}).then(({
			value
		}) => {
			obj.success && obj.success(value);
		}).catch(() => {
			obj.fail && obj.fail();
		});
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/popup.js